import { createPromiseClient } from '@bufbuild/connect';
import { ConnectTransportOptions } from '@bufbuild/connect-web';

import {
  ResponseStatusCodeFunction,
  lmsTransport,
  lmsTransportWithLogoutHandler,
} from './transports';
import { SchoolAssessmentAPIServiceV2 } from '@protos/analysis_management/analysis.assessment.apis_connect';

export const SchoolAssessmentAPIServiceV2Client = createPromiseClient(
  SchoolAssessmentAPIServiceV2,
  lmsTransport
);
//SchoolAssessmentAPIServiceV2
export const useSchoolAssessmentAPIServiceV2ClientWithStatusCodeHandler = (
  options: Partial<ConnectTransportOptions>,
  responseStatusCodeFunction: ResponseStatusCodeFunction
) =>
  createPromiseClient(
    SchoolAssessmentAPIServiceV2,
    lmsTransportWithLogoutHandler(options, responseStatusCodeFunction)
  );
